import { Injectable, EventEmitter, Output } from '@angular/core';
import * as moment from 'moment';
import { OptionInterface } from '../../../models/interfaces';
import { filterSent, FilterTypeEnum } from '../../../models/column-types';
import { EnumDataType } from '../../../models/data-type-list';

@Injectable({
  providedIn: 'root'
})
export class TranslateSearchService {

  @Output() searchConverted: EventEmitter<string> = new EventEmitter<string>();
  @Output() clearFilters: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() clearMultiple: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() newSelect: EventEmitter<OptionInterface> = new EventEmitter<OptionInterface>();

  filterBoard: filterSent[] = [];
  filterMultiple: filterSent[] = [];

  translatePayloadMain(filters?: filterSent[], multiple: boolean = false): void {
    let totalFilters = [];
    let searchRequest: string = '';
    let index: number = 0;
    this.clearMultiple.emit(true);

    if (filters) {
      if (!multiple) {
        totalFilters = [...filters];
        if (this.filterMultiple.length > 0) totalFilters.push(this.filterMultiple[0]);
        this.filterBoard = [...filters];
      } else {
        totalFilters = [...this.filterBoard];
        totalFilters.push(filters[0]);
        totalFilters.push(filters[1]);
        this.filterMultiple = [...filters];
      }
      for (const filter of totalFilters) {
        if (!filter.value && filter.value !== false) {
          filters.splice(index);
        } else {
          let searchFilter = this.translatePayloadSingle(filter.value, filter.key, filter.type, multiple);
          searchRequest += searchRequest.length == 0 ? searchFilter : ' and ' + searchFilter;
          index++;
        }
      }
    } else {
      if (multiple) {
        this.filterMultiple = [];
      } else {
        this.filterBoard = [];
      }
    }
    this.searchConverted.emit(searchRequest);
  }

  translatePayloadSingle(filter, key: string, type: string, multiple: boolean): string {
    let param: string;
    switch (type) {
      case FilterTypeEnum.TEXT:
        const filterType = filter as string;
        param = multiple ? key + ' eq ' + "'" + filter + "'" : "substringof('" + filterType.toUpperCase() + "',toupper(" + key + "))";
        break;

      case FilterTypeEnum.DATE:
        let dateString1: string = moment(filter[0]).utc().format()
        let dateString2: string = this.changeDate(filter[1]);
        param = key + " ge datetime'" + dateString1 + "' and " + key + " le datetime'" + dateString2 + "'";
        break;

      case FilterTypeEnum.NUMBER:
        param = key + ' eq ' + filter;
        break;

      case FilterTypeEnum.SELECT:
        if (typeof filter === EnumDataType.boolean) {
          param = key + ' eq ' + filter;
        }
        else {
          const filterType = filter;
          const regex = /^\d*$/;
          const isNumber = regex.test(filterType);
          param = key + ' eq ' + "'" + filter + "'";
          if (isNumber) param = key + ' eq ' + filter;
        }
        break;

      case FilterTypeEnum.AUX:
        param = key + ' eq ' + "'" + filter + "'";
        break;
    }

    return param;
  }

  changeDate(filter): string {
    return moment(filter).utc().add(1, 'days').format();
  }

  clearMult(): void {
    this.filterMultiple = [];
    this.clearMultiple.emit(true);
  }

}
